import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';

const CopyToClipboard = ({ value }) => {
    const { t } = useTranslation();

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (err) {
            console.error('Copy failed', err);
        }
    };

    return (
        value && <Tooltip title={t("Copy object ID")}>
            <IconButton onClick={handleCopy} size="small" sx={{ width: '30px', height: '30px', margin: '5px 0 0 5px' }}>
                <ContentCopyIcon sx={{ fontSize: '14px' }} />
            </IconButton>
        </Tooltip>
    );
};

export default CopyToClipboard;
